import { request } from "./request";

export function insert(year, title, author, journal, partition, createdUser, fileLength) {
  return request({
    url: '/article/insert',
    params: {
      year, title, author, journal, partition, createdUser, fileLength
    }
  })
}

export function queryArticle() {
  return request({
    url: '/article/queryArticle'
  })
}

export function modifyArticle(id, year, title, author, journal, partition, createdUser, fileLength) {
  return request({
    url: '/article/modifyArticle',
    params:{
      id, year, title, author, journal, partition, createdUser, fileLength
    }
  })
}

export function deleteArticle(id) {
    return request({
      url: '/article/deleteArticle',
      params:{ id }
    })
}